// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
var _ = require('lodash');
import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import Button from 'grommet/components/Button';
import CheckBox from 'grommet/components/CheckBox';
import FormField from 'grommet/components/FormField';

import EditControl from './Controls';
import DeepSensorControl from './DeepSensorControl';
import constants from '../../Constants';
import { checkForNumber } from '../../utils/Utility';
var alertData = {};
class EditAlert extends Component {

  constructor(props) {
    super(props);
    this.state = {
      show: this.props.show,
      cateogories: this.getCategories(),
      alert: '',
      name: '',
      description: '',
      sensedParameter: '',
      sensedValueKey: '',
      sensedValue: '',
      notificationType: 'email',
      notificationValue: ''
    }
    this.getCategories = this.getCategories.bind(this);
    this.saveAlert = this.saveAlert.bind(this);
    this.dataChange = this.dataChange.bind(this);
    this.getNameByKey = this.getNameByKey.bind(this);
  }
  componentWillMount() {
    if (this.props.addMode) {
      alertData['actions'] = { email: '' }
      alertData['sensedValueKey'] = 'gt';
      this.setState({
        sensedParameter: alertData['sensedParameter']
      })
    } else {
      this.setState({
        alert: this.props.alertItem.alert,
        name: this.props.alertItem.alert.name,
        description: this.props.alertItem.alert.description,
        sensedParameter: this.props.alertItem.alertDetails.detailsKey,
        sensedValueKey: this.props.alertItem.alertDetails.condition,
        sensedValue: this.props.alertItem.alert.triggers[this.props.alertItem.alertDetails.detailsKey][this.props.alertItem.alertDetails.condition],
        notificationType: this.props.alertItem.alertDetails.alertType,
        notificationValue: this.props.alertItem.alert.actions[this.props.alertItem.alertDetails.alertType]
      })
    }

  }


  componentDidMount() {
    // ReactDOM.findDOMNode(this.refs.editTwigOverlay).scrollTop = 0;
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      show: nextProps.show
    })
  }

  componentWillUnmount() {
    alertData = {};
  }

  getCategories() {
    let optionsArr = [];
    for (let key in this.props.selectedTwig.details.data) {
      let item = this.props.selectedTwig.details.data[key];
      item['key'] = key;
      optionsArr.push(item)
    }

    const filterObjects = optionsArr.sort((a, b) => a.sort_order - b.sort_order).filter(each => each.sort_order !== 1 && each.sort_order !== 6);
    alertData['sensedParameter'] = filterObjects[0].key;
    return filterObjects;
  }

  dataChange(key, event) {
    let value = event.target.value;
    if (key == 'sensedValue') {
      let isNumber = checkForNumber(value);
      if (isNumber) {
        this.setState({
          [key]: value
        }, () => {
          alertData[key] = value;
        })
      }
    } else {
      this.setState({
        [key]: value
      }, () => {
        if (key == 'notificationType' || key == 'notificationValue') {
          alertData['actions'] = {};
          if (key == 'notificationType') {
            alertData['actions'][value] = this.state.notificationValue;
          } else {
            alertData['actions'][this.state.notificationType] = value;
          }

        } else {
          alertData[key] = value;
        }
      })
    }

  }
  saveAlert() {
    let alertId = '';
    let value;
    if (this.state.sensedValue !== '') {
      if (this.props.addMode) {
        alertData['isEnabled'] = true;
      } else {
        alertData['sensedValueKey'] = this.state.sensedValueKey
        alertId = this.state.alert.id;
      }
      let label = this.getNameByKey(this.state.sensedParameter);

      alertData['name'] = 'ALERT ' + label;
      let condition = this.state.sensedValueKey == 'gt' ? 'is above' : 'is below';
      alertData['description'] = label + ' around Stem ' + this.props.selectedTwig.name + ' ' + condition + ' ' + this.state.sensedValue;
        // console.log(':::::::alertData::::', alertData)
      this.props.addAlert(alertData, alertId);
    } else {
      alert('Please enter alert setting value.')
    }

  }

  getNameByKey(key) {
    let label = '';
    for (let i = 0; i < this.state.cateogories.length; i++) {
      if (this.state.cateogories[i].key == key) {
        label = this.state.cateogories[i].label
        break;
      }
    }
    return label.toUpperCase();
  }


  render() {
    let toRender = null;

    return (
      <div className={'map-overlay ' + (this.props.show ? 'show' : 'hide')} >
        <div className="edit-twig-content" ref="editTwigOverlay">
          <h2>Add/Update Alert</h2>
          <div className="edit-controls">
            {/*<div className="item maxwidth">
              <div className="label inlineblock width-30">Alert Name</div>
              <div className="control inlineblock">
                <input className="maxwidth" type="text" value={this.state.name} onChange={this.dataChange.bind(this, 'name')} />
              </div>
            </div>
            <div className="item maxwidth">
              <div className="label inlineblock width-30">Alert Description</div>
              <div className="control inlineblock">
                <input className="maxwidth" type="text" value={this.state.description} onChange={this.dataChange.bind(this, 'description')} />

              </div>
            </div>*/}
            <div className="item maxwidth">
              <div className="label inlineblock width-30">Alert Category</div>
              <div className="control inlineblock">
                <select className="maxwidth" value={this.state.sensedParameter} onChange={this.dataChange.bind(this, 'sensedParameter')}>
                  {
                    this.state.cateogories.map((item, index) => {
                      return (
                        <option value={item.key} key={index}>{item.label}</option>
                      )
                    })
                  }
                </select>

              </div>
            </div>
            <div className="item maxwidth">
              <div className="label inlineblock width-30">Alert Setting</div>
              <div className="control inlineblock width-30 mr-10">
                <select className="maxwidth" value={this.state.sensedValueKey} onChange={this.dataChange.bind(this, 'sensedValueKey')}>
                  <option value='gt'>EXCEEDS</option>
                  <option value='lt'>FALLS BELOW</option>
                </select>
              </div>
              <div className="control inlineblock width-30">
                <input className="maxwidth" type="text" value={this.state.sensedValue} onChange={this.dataChange.bind(this, 'sensedValue')} />
              </div>
            </div>
            <div className="item maxwidth">
              <div className="label inlineblock width-30">Notification</div>
              <div className="control inlineblock width-30 mr-10">
                <select className="maxwidth" value={this.state.notificationType} onChange={this.dataChange.bind(this, 'notificationType')}>
                  <option value='email'>EMAIL</option>
                  <option value='sms'>SMS</option>
                  <option value='iftt'>IFTT</option>
                </select>
              </div>
              <div className="control inlineblock width-30">
                <input className="maxwidth" type="text" value={this.state.notificationValue} onChange={this.dataChange.bind(this, 'notificationValue')} />
              </div>
            </div>


          </div>

          <div className="overlay-btn-container">
            <Button
              label={this.props.addMode ? 'Save' : 'Update'}
              onClick={this.saveAlert}
              primary={true}
              className="mr-5" />
            <Button
              label='Cancel'
              onClick={this.props.closePopup}
              primary={true} />
          </div>
        </div>
      </div>
    );
  }

}

export default EditAlert;




// WEBPACK FOOTER //
// ./src/js/components/site/EditAlert.js